import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { imgSrc } from "@/lib/categories";
import { uploadImage } from "@/lib/upload";

export function PhotoUpload({ value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadImage(api, file));
      toast.success("Photo uploaded");
    } catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="flex items-center gap-4">
      <button type="button" data-testid="biz-photo-upload" onClick={() => ref.current?.click()} disabled={busy}
        className="relative h-24 w-32 rounded-xl border border-dashed border-[#26334D] hover:border-[#FF3B6B] bg-[#0B0F19] overflow-hidden grid place-items-center transition-colors">
        {value ? <img data-testid="biz-photo-preview" src={imgSrc(value)} alt="" className="h-full w-full object-cover" />
          : busy ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
          : <span className="flex flex-col items-center text-xs text-slate-400 gap-1"><ImagePlus className="h-5 w-5" /> Upload photo</span>}
      </button>
      <div className="text-xs text-slate-500 space-y-2">
        <p>JPG, PNG or WEBP · up to 8 MB</p>
        {value && (
          <button type="button" data-testid="biz-photo-remove" onClick={() => onChange("")} className="flex items-center gap-1 text-[#FF7A7A]">
            <X className="h-3.5 w-3.5" /> Remove
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" hidden data-testid="biz-photo-input" onChange={pick} />
    </div>
  );
}
